import styled from 'styled-components';
import { Routes, Route, useNavigate } from 'react-router-dom';

import QRCodeSelection from './QRCodeSelection';

import { MobileFullscreen, FloatingButton } from '~ui-kit';

const QRMenuWrapper = ({ children, options }) => {
  const navigate = useNavigate();

  if (!window.cordova) return children;

  return (
    <Container>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <FloatingButton
                onClick={() => navigate('qr-code')}
                title="Lue QR-koodi"
                faIcon="fa-qrcode"
              />
              {children}
            </>
          }
        />
        <Route
          path="/qr-code"
          element={
            <MobileFullscreen back={() => navigate(-1)}>
              <QRCodeSelection back={() => navigate(-1)} options={options} />
            </MobileFullscreen>
          }
        />
      </Routes>
    </Container>
  );
};

const Container = styled.div``;

export default QRMenuWrapper;
